import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { ChevronDownIcon } from '../../icons';
import { useMemo } from 'react';
export function MonthPicker({ value, onChange }) {
    const months = useMemo(() => [
        'January', 'February', 'March', 'April', 'May', 'June',
        'July', 'August', 'September', 'October', 'November', 'December',
    ], []);
    return (_jsx("div", { className: "relative", children: _jsxs("div", { className: "flex items-center gap-1", children: [_jsx("select", { value: value, onChange: (e) => {
                        const month = parseInt(e.target.value, 10);
                        onChange(month);
                    }, className: "appearance-none bg-transparent py-1 px-2 text-sm text-gray-700 font-medium cursor-pointer rounded-md hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-indigo-600 pr-6", children: months.map((monthName, index) => (_jsx("option", { value: index + 1, children: monthName }, monthName))) }), _jsx(ChevronDownIcon, { className: "size-3.5 text-gray-500 absolute right-2 pointer-events-none" })] }) }));
}
